import { V } from "../misc/Vector.js";
import { Trajectory } from "./Trajectory.js";
import { GeometryUtils as G } from "../utils/Geometry.js";
import Flatten from "@flatten-js/core";
export { EndTrajectory };
const ARC_ANGLE_EPSILON = 1e-3;
class EndTrajectory extends Trajectory {
    constructor({ tangent, point, direction, rotation, waypoint, center, radius, width, spacing, connection }) {
        super({ waypoint, center, radius, width, spacing, connection });
        this.tangent = tangent;
        this.point = point;
        this.direction = direction;
        this.rotation = rotation !== null && rotation !== void 0 ? rotation : G.rotation(V.subtract(point, center), direction);
    }
    clone() {
        return new EndTrajectory({
            tangent: this.tangent,
            point: this.point,
            direction: this.direction,
            rotation: this.rotation,
            waypoint: this.waypoint,
            center: this.center,
            radius: this.radius,
            width: this.width,
            spacing: this.spacing,
            connection: this.connection
        });
    }
    getAngles() {
        const bPoint = this.tangent.getPoint(this);
        const vA = V.subtract(this.point, this.center);
        const vB = V.subtract(bPoint, this.center);
        const vApAngle = G.normalizedAngle(vA);
        const vApAngleReal = V.angle(vA);
        const vBAngle = G.normalizedAngle(vB);
        const vBAngleReal = V.angle(vB);
        const a = (vApAngle + (this.rotation > 0 ? ARC_ANGLE_EPSILON : -ARC_ANGLE_EPSILON));
        const vAAngle = a >= 2 * Math.PI ? a - 2 * Math.PI : a;
        const aReal = (vApAngleReal + (this.rotation > 0 ? ARC_ANGLE_EPSILON : -ARC_ANGLE_EPSILON));
        const vAAngleReal = aReal > Math.PI ? aReal - 2 * Math.PI : (aReal <= Math.PI ? aReal + 2 * Math.PI : aReal);
        const arcp = new Flatten.Arc(new Flatten.Point(this.center[0], this.center[1]), this.radius, vApAngle, vBAngle, this.rotation > 0);
        const arc = new Flatten.Arc(new Flatten.Point(this.center[0], this.center[1]), this.radius, vAAngle, vBAngle, this.rotation > 0);
        if (vAAngle === vBAngle) {
            return [vBAngleReal, vBAngleReal];
        }
        if (arcp.sweep < Math.PI && arc.sweep >= Math.PI) {
            return [vBAngleReal, vBAngleReal];
        }
        else {
            return this.rotation > 0 ? [vAAngleReal, vBAngleReal] : [vBAngleReal, vAAngleReal];
        }
    }
    getArc() {
        const bPoint = this.tangent.getPoint(this);
        const vA = V.subtract(this.point, this.center);
        const vB = V.subtract(bPoint, this.center);
        const vApAngle = G.normalizedAngle(vA);
        const vBAngle = G.normalizedAngle(vB);
        const a = (vApAngle + (this.rotation > 0 ? ARC_ANGLE_EPSILON : -ARC_ANGLE_EPSILON));
        const vAAngle = a >= 2 * Math.PI ? a - 2 * Math.PI : a;
        const arcp = new Flatten.Arc(new Flatten.Point(this.center[0], this.center[1]), this.radius, vApAngle, vBAngle, this.rotation > 0);
        const arc = new Flatten.Arc(new Flatten.Point(this.center[0], this.center[1]), this.radius, vAAngle, vBAngle, this.rotation > 0);
        if (vAAngle === vBAngle) {
            return new Flatten.Point(bPoint[0], bPoint[1]);
        }
        if (arcp.sweep < Math.PI && arc.sweep >= Math.PI) {
            return new Flatten.Point(bPoint[0], bPoint[1]);
        }
        else {
            return arc;
        }
    }
    intersects(pointA, pointB) {
        const EPSILON = 1e-6;
        if (V.distance(pointA, pointB) < EPSILON) {
            return false;
        }
        const segment = new Flatten.Segment(new Flatten.Point(pointA[0], pointA[1]), new Flatten.Point(pointB[0], pointB[1]));
        const arc = this.getArc();
        const tangent = new Flatten.Segment(new Flatten.Point(this.tangent.sourcePoint[0], this.tangent.sourcePoint[1]), new Flatten.Point(this.tangent.targetPoint[0], this.tangent.targetPoint[1]));
        return segment.intersect(arc).length !== 0 || segment.intersect(tangent).length !== 0;
    }
    arcIntersects(arc) {
        if (arc instanceof Flatten.Point) {
            return false;
        }
        const EPSILON = 1e-6;
        if (arc.length < EPSILON) {
            return false;
        }
        const trajectoryArc = this.getArc();
        const tangent = new Flatten.Segment(new Flatten.Point(this.tangent.sourcePoint[0], this.tangent.sourcePoint[1]), new Flatten.Point(this.tangent.targetPoint[0], this.tangent.targetPoint[1]));
        return arc.intersect(trajectoryArc).length !== 0 || arc.intersect(tangent).length !== 0;
    }
    getTangents() {
        return [this.tangent];
    }
}
//# sourceMappingURL=EndTrajectory.js.map